import React, {useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {StyledExpensesTab} from './StyledExpensesTab';
import EmptyOrTable from '../../../EmptyOrTable';
import TableFilters from '../ExpenseDetailsPanelTabs/tabComponents/TableFilters';
import LoadMoreButton from '../../TransactionsPage/LoadMoreButton';
import { getExpensesTabColumns } from './ExpensesTabColumns';


const ExpensesTab = ({
  data = [],
  empty,
  loading = false,
  loadMoreProps = {},
  onApprove,
  onFilter,
  onReject,
  tableFiltersProps,
  tableProps,

  dispatch,
  isAdmin,
  employeeEmail,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'accounting']);
  const [query, setQuery] = useState({ search: '' });

  const handleOnFilter = (filterParams) => {
    setQuery({...query, ...filterParams});
    onFilter?.(filterParams);
  }

  const columns = getExpensesTabColumns({
    t,
    isAdmin,
    employeeEmail,
    onApprove,
    onReject
  });

  return (
    <StyledExpensesTab
      {...rest}
      size='large'
      direction='vertical'
    >
      <TableFilters
        {...tableFiltersProps}
        onFilter={handleOnFilter}
      />
      <EmptyOrTable
        data={data}
        empty={empty}
        loading={loading}
        query={query}
        columns={columns}
        tableProps={tableProps}
      />
      <LoadMoreButton
        {...loadMoreProps}
        loading={loading || loadMoreProps.loading}
        size='large'
      >
        {t('showMore')}
      </LoadMoreButton>
    </StyledExpensesTab>
  );
}

ExpensesTab.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  empty: PropTypes.any,
  loading: PropTypes.bool,
  onFilter: PropTypes.func,
  tableFiltersProps: PropTypes.any,
  tableProps: PropTypes.object
}

const mapStateToProps = ({ user: { isAdmin, employee } }) => ({
  isAdmin,
  employeeEmail: employee?.email
});

export default connect(mapStateToProps, null)(ExpensesTab);
